import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const DragHandleIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '15';
			default:
				return '15';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '14';
			case SIZE.STANDARD:
				return '15';
			default:
				return '15';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};
	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} viewBox="0 0 16 16">
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="drag-handle" fill={color}>
						<rect id="Rectangle" x="5" y="1" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-4" x="9" y="1" width="2" height="2"></rect>
						<rect id="Rectangle-Copy" x="5" y="5" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-5" x="9" y="5" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-2" x="5" y="9" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-6" x="9" y="9" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-3" x="5" y="13" width="2" height="2"></rect>
						<rect id="Rectangle-Copy-7" x="9" y="13" width="2" height="2"></rect>
					</g>
				</g>
			</svg>
		</StyledSpan>
	);
};

DragHandleIcon.SIZE = SIZE;
DragHandleIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	opacity: PropTypes.number,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

DragHandleIcon.defaultProps = {
	opacity: 1,
};
export const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
